<template>
	<section class="PageNotFoundPage">
		<p>Pagina niet gevonden</p>
	</section>
</template>

<script>
	export default {
	};
</script>
